import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';

function Screen(props) {
    const hasPerms = props.control.permissions
    // console.log(hasPerms)
   
    return(
        <div className='w-full h-full bg-[#0C0D14] pb-12' style={{overflowY:'auto'}}>
            <iframe title='BIM Model Viewer' className='w-full h-full' src={`/bim/index.html?projectId=OTCConferenceCenter&tab=storeys`} />
        </div>
    )
}

export default connect((store) => {
    return {
      token: store.tokenReducer,
      control: store.controlReducer,
    }
  })(Screen)